import React from 'react';

import { Link } from 'react-router-dom';

import { StyledArticleCard } from './ArticleCard.styled';

import { PrismicImage, PrismicRichText } from '@prismicio/react';

const ArticleCard = ({ article }) => {
  const options = {
    heading1: ({ children }) => <h3 className="card__title">{children}</h3>,
    paragraph: ({ children }) => <p className="card__desc">{children}</p>,
  };

  const date = new Date(article?.data.timestamp);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');

  return (
    <StyledArticleCard className="card">
      <Link
        to={`/articles/${year}/${month}/${article?.uid}`}
        className="card__link--title"
      >
        <PrismicRichText field={article?.data.title} components={options} />
      </Link>
      <PrismicRichText field={article?.data.intro} components={options} />
      <Link
        className="card__link"
        to={`/articles/${year}/${month}/${article?.uid}`}
      >
        Link
      </Link>
      <p className="card__timestamp">{date.toLocaleDateString('pl-PL')}</p>
      <Link
        className="card__link--image"
        to={`/articles/${year}/${month}/${article?.uid}`}
      >
        <PrismicImage field={article?.data.image} className="card__image" />
      </Link>
    </StyledArticleCard>
  );
};

export default ArticleCard;

